import { combineReducers } from 'redux'
import * as reducers from './Index'

const rootReducer = combineReducers(reducers)
export default rootReducer
